import { MobileSectorVm, OptionVm } from '@app/entities/flight-results';
import { isNullOrUndefined } from '@app/util/util';

export function getFlightKeys(itineraryId: number, sector: MobileSectorVm | OptionVm): string {
  return keys(itineraryId, sector);
}

function keys(itineraryId: number, sector: MobileSectorVm | OptionVm): string {
  if (!isNullOrUndefined(itineraryId)) {
    return sector.FlightKeys ? `${itineraryId}_${sector.FlightKeys}` : `${itineraryId}_${buildKeys(sector)}`;
  } else return sector.FlightKeys ? sector.FlightKeys : buildKeys(sector);
}

function buildKeys(sector: MobileSectorVm | OptionVm): string {
  const flightKeys = [];
  sector.Flights.forEach(flight => flightKeys.push(`${flight.AirlineCode}${flight.Number}`));
  return flightKeys.join();
}
